module.exports = function(options) {

    return {
        ...options,

        // Overwrite options
        language: 'en',

        // Add styles
        stylesSet: [
            {name: 'Normal', element: 'span', attributes: {'class': ''}},
            {name: 'Primaire knop', element: 'a', attributes: {'class': 'btn-primary'}},
            {name: 'Secundaire knop', element: 'a', attributes: {'class': 'btn-secondary'}},
            {name: 'Tertiaire knop', element: 'a', attributes: {'class': 'btn-tertiary'}},

            {name: "Heading 1", element: "span", attributes: {"class": "h1"}},
            {name: "Heading 2", element: "span", attributes: {"class": "h2"}},
            {name: "Heading 3", element: "span", attributes: {"class": "h3"}},
            {name: "Heading 4", element: "span", attributes: {"class": "h4"}},
            {name: "Heading 5", element: "span", attributes: {"class": "h5"}},

            {name: 'Primaire knop omgekeerd', element: 'a', attributes: {'class': 'btn-primary-inverse'}},
            {name: 'Secundaire knop omgekeerd', element: 'a', attributes: {'class': 'btn-secondary-inverse'}},
            {name: 'Tertiaire knop omgekeerd', element: 'a', attributes: {'class': 'btn-tertiary-inverse'}},

            ...options.stylesSet,
        ],

    };

};